<style lang="scss">
	#on-center {
		.ant-form-item-label {
			margin-top: 1.5rem;
		}
	}

	#handitemedit2 {
		.ant-row, .ant-calendar-picker{
			width: 100%;
		}

		.ant-form-item-label {
			width: 15% !important;
		}

		.ant-form-item-control-wrapper {
			width: 66% !important;

			.wart-t {
				width: 100%;
			}
		}
		.ant-calendar-picker-input{
			width: 100%;
		}
		.myright{
			.ant-form-item-label {
				width: 34% !important;
				padding-left: 5%;
			}
		}
		.warp_long {
			width: 50%;
			display: inline-block;

			.ant-form-item-label {
				width: 30% !important;
			}

			.ant-form-item-control-wrapper {
				width: 60% !important;

			}
		}
		.formItem{
			.ant-form-item-children{
				display: flex;
				justify-content: space-between;
			}
			.ant-calendar-picker, .valinput{
				width: 45%;
			}
		}
		.texright {
			text-align: right;
			// margin-left: 4%;
		}
	}
	.baojianr_div{
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		width: 100%;
		height: 1.75rem;
    	font-size: 0.8rem;
		margin-top: 0.2rem;
		padding: 0 11px;
		display: flex;
		align-items: center;
	}
	.baojianr_div_add{
		width: 14px;
		margin-left: auto;
		cursor: pointer;
		flex-shrink: 0;
	}
	.xgrq_div .ant-calendar-picker-icon{
		top: 43% !important;
	}
</style>
<template>
	<div id='handitemedit2'>
		<div class="tabelMoreFzView main-mybody">
			<div class="tabelMoreFzViewIn">
				<a-form-model ref='ruleForm' :model="form" labelAlign='left' layout="inline" :rules='rules'
					hideRequiredMark>
					<a-row>
						<a-col :span='12'>
							<a-form-model-item label="股票簡稱" prop='stockname'>
								<div style="width: 100%;position: relative;">
									<a-input v-model="form.stockname" placeholder="參考香港披露易" class='warp_width' :maxLength='10' :disabled='ipoAduitAdmin'/>
									<span style="position: absolute;right: 11px;color: #bfbfbf;">{{form.stockname.length}}/10</span>
								</div>
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Short Name" prop='stockname_en'>
								<a-input v-model="form.stockname_en"  placeholder="Reference to HKEX nwes" class='warp_width' 
								@input="form.stockname_en=form.stockname_en.replace(/[\u4E00-\u9FA5]+/g,'')"
								  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>

							<a-form-model-item label="股票代碼" :prop='form.status_cn!==0?"stockcode":""'>
								<a-input v-model="form.stockcode" @blur='stockcodeFn("stockcode")' class='warp_width'
									:maxLength='5'  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Stock Code" :prop='form.status_cn!==0?"stockcode":""'>
								<a-input v-model="form.stockcode" @blur='stockcodeFn("stockcode")' class='warp_width'
									:maxLength='5'  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<div id='on-center1'>
								<a-form-model-item label="新股類型" prop='ipo_type'>
									<a-select v-model="form.ipo_type" :disabled='ipoAduitAdmin'>
										<a-select-option :value="1">證券</a-select-option>
										<a-select-option :value="2">債券</a-select-option>
									</a-select>
								</a-form-model-item>
							</div>
						</a-col>
						<a-col :span='12' class='myright'>
							<div id='on-center1'>
								<a-form-model-item label="IPO Type" prop='ipo_type'>
									<a-select v-model="form.ipo_type" :disabled='ipoAduitAdmin'>
										<a-select-option :value="1">Securities</a-select-option>
										<a-select-option :value="2">Bond</a-select-option>
									</a-select>
								</a-form-model-item>
							</div>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label='上市日期' prop='listingdate'>
								<a-date-picker v-model="form.listingdate" type="date" @change="handback('listingdate')"
									:disabled-date="disabledDate" class='warp_width' placeholder="" :disabled='ipoAduitAdmin'/>
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label='Listing Date' prop='listingdate'>
								<a-date-picker v-model="form.listingdate" type="date" @change="handback('listingdate')"
									:disabled-date="disabledDate" class='warp_width' placeholder=""  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label="暗盤日期">
								<!-- prop='anpantime' -->
								<a-date-picker v-model="form.anpantime" type="date" @change="handback('anpantime')"
									class='warp_width' placeholder="" :disabled-date="deliveryDate"  :disabled='ipoAduitAdmin' />
								<!-- :disabled='form.anpantime?true:false' -->
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Grey Market Date">
								<a-date-picker v-model="form.anpantime" type="date" @change="handback('anpantime')"
									class='warp_width' placeholder="" :disabled-date="deliveryDate"  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label='入場費' prop='entryfee'>
								<a-input v-model="form.entryfee" class='warp_width' @blur='stockcodeFn("entryfee",1)'  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label='Entry Fee' prop='entryfee'>
								<a-input v-model="form.entryfee" class='warp_width' @blur='stockcodeFn("entryfee",1)'  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label='每手股數' prop='pergshu'>
								<a-input v-model="form.pergshu" class='warp_width' @blur='stockcodeFn("pergshu")'  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label='Board Lot' prop='pergshu'>
								<a-input v-model="form.pergshu" class='warp_width' @blur='stockcodeFn("pergshu")'  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label="認購日期" class="formItem xgrq_div" prop='application_open'>
								<a-date-picker class='dateinput' v-model='form.application_open' placeholder=""
									:disabled-date="disabledDate" @change="handback('application_open')">
									<template slot="dateRender" slot-scope="current, today">
										<div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
											{{ current.date() }}
										</div>
									</template>
								</a-date-picker>
								<div class='warp_a'>~</div>
								<a-date-picker class='dateinput' v-model='form.application_close'
									:disabled-date="applicationDate" @change="handback('application_close')"
									placeholder="">
									<template slot="dateRender" slot-scope="current, today">
										<div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
											{{ current.date() }}
										</div>
									</template>
								</a-date-picker>
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Application Period" class="formItem xgrq_div" prop='application_open'>
								<a-date-picker class='dateinput' v-model='form.application_open' placeholder=""
								:disabled='ipoAduitAdmin'
									:disabled-date="disabledDate" @change="handback('application_open')">
									<template slot="dateRender" slot-scope="current, today">
										<div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
											{{ current.date() }}
										</div>
									</template>
								</a-date-picker>
								<div class='warp_a'>~</div>
								<a-date-picker class='dateinput' v-model='form.application_close'
									:disabled-date="applicationDate" @change="handback('application_close')"
									:disabled='ipoAduitAdmin'
									placeholder="">
									<template slot="dateRender" slot-scope="current, today">
										<div class="ant-calendar-date" :style="getCurrentStyle(current, today)">
											{{ current.date() }}
										</div>
									</template>
								</a-date-picker>
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label="招股價" class="formItem" prop='offer_price_l'>
								<a-input v-model="form.offer_price_l" class='valinput'
									@blur='stockcodeFn("offer_price_l",1)'   />
								<div class='warp_a'>~</div>
								<a-input v-model="form.offer_price_h" class='valinput'
									@blur='stockcodeFn("offer_price_h",1)'   />
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Offer Price" class="formItem" prop='offer_price_l'>
								<a-input v-model="form.offer_price_l" class='valinput'
									@blur='stockcodeFn("offer_price_l",1)'  :disabled='ipoAduitAdmin' />
								<div class='warp_a'>~</div>
								<a-input v-model="form.offer_price_h" class='valinput'
									@blur='stockcodeFn("offer_price_h",1)'  :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label="保薦機構" prop='baojianr'>
								<div class="baojianr_div" @click="add_inp()" :style="{borderColor:cla1?'red':''}"> 
									<div style="white-space: nowrap; overflow: hidden;text-overflow: ellipsis;padding-right: 5px;" :title="baojianr_div_ch">{{baojianr_div_ch}}</div>
									<img class="baojianr_div_add" :style="{cursor:!ipoAduitAdmin?'pointer':'no-drop'}" src="../../../image/tj.png"  >
								</div>
								<!-- <Situationall v-model="form.baojianr"
									:url='$api.getParamList'
									:disabled='ipoAduitAdmin'
									:params='{"type":"baojianr"}'
									:valstr='form.baojianrval'
									:style='"width: 100%;"'>
								</Situationall>
								<a-popover :visible="visibles1" placement="top" trigger="click"
									:destroyTooltipOnHide="true" :overlayStyle="{width:'calc(25rem)'}"
									@visibleChange="moreEvent1()"
									:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
									<template slot="content">
										<div>
											<div id='on-center'>
												<a-textarea v-model="form.baojianr"
													:auto-size="{ minRows: 4, maxRows: 5 }" @input="baofn"
													placeholder="多個保薦機構請用分號（ ; ）" class='wart-t word-abc'  :disabled='ipoAduitAdmin' />
											</div>
										</div>
									</template>
									<img title='點擊添加更多' src="@/image/images.png" class='myupload' alt="">
								</a-popover> -->
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Sponsor" prop='baojianr_en'>
								<div class="baojianr_div" @click="add_inp()" :style="{borderColor:cla2?'red':''}"> 
									<div style="white-space: nowrap; overflow: hidden;text-overflow: ellipsis;padding-right: 5px;" :title="baojianr_div_en">{{baojianr_div_en}} </div>
									<img class="baojianr_div_add" :style="{cursor:!ipoAduitAdmin?'pointer':'no-drop'}" src="../../../image/tj.png">
								</div>
								<!-- <Situationall v-model="form.baojianr_en"
									:url='$api.getParamList'
									:disabled='ipoAduitAdmin'
									:params='{"type":"baojianr_en"}'
									:valstr='JSON.parse(JSON.stringify(form)).baojianr_enval'
									:style='"width: 100%;"'>
								</Situationall>
									
								<a-popover :visible="visibles2" placement="top" trigger="click"
									:destroyTooltipOnHide="true" :overlayStyle="{width:'calc(25rem)'}"
									@visibleChange="moreEvent2()"
									:getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
									<template slot="content">
										<div>
											<div id='on-center'>
												<a-textarea v-model="form.baojianr_en"
													:auto-size="{ minRows: 4, maxRows: 5 }" @input="baofn"
													placeholder="Please use the semicolon ( ; ) for multiple sponsors" class='wart-t word-abc'  :disabled='ipoAduitAdmin' />
											</div>
										</div>
									</template>
									<img title='點擊添加更多' src="@/image/images.png" class='myupload' alt="">
								</a-popover> -->
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<a-form-model-item label="超額倍數">
								<a-input v-model="form.multiple" class='warp_width' @blur='stockcodeFn("multiple")' 
								 :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12' class='myright'>
							<a-form-model-item label="Over-sub. Rate">
								<a-input v-model="form.multiple" class='warp_width' @blur='stockcodeFn("multiple")' 
								 :disabled='ipoAduitAdmin' />
							</a-form-model-item>
						</a-col>
						<a-col :span='12'>
							<div id='on-center1'>
								<a-form-model-item label="招股書">
									<a-input v-model="form.linkaddress" class='wart-t'  :disabled='ipoAduitAdmin' />
								</a-form-model-item>
							</div>
						</a-col>
						<a-col :span='12' class='myright'>
							<div id='on-center1'>
								<a-form-model-item label="Prospectus">
									<a-input v-model="form.linkaddress_en" class='wart-t'  :disabled='ipoAduitAdmin' />
								</a-form-model-item>
							</div>
						</a-col>

					</a-row>
				</a-form-model>
			</div>
		</div>
		<div class='warp_daochu' v-if='ipoAduitAdmin'>
			<!-- <div style="padding-left: .5rem;" :style='{width:!form.shKhadmin1Bol? "27rem":"34.5rem"}'>
				<a-textarea v-model='form.remark' placeholder=" " allow-clear style='width: 100%;' />
			</div>
			<div style="padding: .35rem 0;" v-if="$store.state.rolesdata.indexOf('khadmin1') >= 0">
				
				<button class='btn1' v-if='!form.shKhadmin1Bol' @click='shTgEvent(record,"2")'
					style="background-color: #ed4849;">取消開戶</button>
				<button class='btn1 btnx'
					@click='shTgEvent(record , "0")'>{{form.shKhadmin1Bol ? '已處理' :'審核通過'}}</button>
			</div>
			<div style="padding: .35rem 0;" v-else>
				<button class='btn1' @click='shUnTgEvent(record,"1")' style="background-color: #ed4849;">審核拒絕</button>
				<button class='btn1 btnx' @click='shTgEvent(record , "0")'>審核通過</button>
			</div> -->
				<div style="padding: .35rem 0;margin-left: auto;">
					<!-- <button class='btn1 btnx' @click='savefn'>保存</button> -->
					<button class='btn1 btnx' style="background-color: #f48d28;" @click='gopagefn()'>下一頁</button>
				</div>
		</div>
		<div class='warp_daochu' v-else>
			<div style="padding: .35rem 0;margin-left: auto;">
				<button class='btn1 btnx' @click='savefn'>保存</button>
				<button class='btn1 btnx' style="background-color: #f48d28;" @click='gopagefn()'>下一頁</button>
			</div>
		</div>
		<addbaojia v-if="baojiaFlag" @child="exchangeRateClick" :baojianr_ch="baojianr_div_ch" :baojianr_en="baojianr_div_en" :items='form'></addbaojia>
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	import addbaojia from './addbaojia.vue';

	export default {
		components: {
			addbaojia
		},
		props: ['record', 'forms'],
		data() {
			return {
				cla1:false,
				cla2:false,
				baojianr_div_ch:'',
				baojianr_div_en:'',
				baojiaFlag:false,
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				visibles2: false,
				visibles1: false,
				rules: {
					stockcode: [{
						required: true,
						message: ' ',
						trigger: ['blur', 'change']
					}],
					stockname_en: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					stockname: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					ipo_type: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					offer_price_l: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					offer_price_h: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					pergshu: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					application_open: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					application_close: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					listingdate: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					entryfee: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_industry_name_cn: [{
						required: true,
						message: '123',
						trigger: 'change'
					}],
					cn_planned_industry_name_en: [{
						required: true,
						message: '123',
						trigger: 'change'
					}],
					cn_planned_company_name_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					cn_planned_company_name_en: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					status_cn: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					plates_cn: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					delivery_date: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					// baojianr: [{
					// 	required: true,
					// 	message: ' ',
					// 	trigger: 'change'
					// }],
					// baojianr_en: [{
					// 	required: true,
					// 	message: ' ',
					// 	trigger: 'change'
					// }],
					anpantime: [{
						required: true,
						message: ' ',
						trigger: 'change'
					}],
					multiple: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					linkaddress: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
					linkaddress_en: [{
						required: true,
						message: ' ',
						trigger: 'blur'
					}],
				},
				
				england: 'cn',
				lang: {},
				admintypeArr: [{
          text: '處理中',
            entext:'Processing',
            value: '0'
          },
          {
            text: '認購中',
            entext:'Subscribing',
            value: '1'
          },
          {
            text: '待上市',
            entext:'Planned IPO',
            value: '2'
          },
          {
            text: '已上市',
            entext:'Listed IPO',
            value: '3'
          },
          {
              text: '已除牌',
            entext:'Delisted',
            value: '4'
          },
          {
              text: '已失效',
            entext:'Expired',
            value: '5'
          }	
        ],
				admintypeArrs: [{
						text: '主板',
						entext: 'Mainboard',
						value: '0'
					},
					{
						text: '創業板',
						entext: 'GEM board',
						value: '1'
					},
				],
				moreFzOption: [],
				form: {
					"pricelist": [{
						"pricekey": "",
						"priceval": ""
					}, ],
					info_en:'',
					stockname_en: '', //股票名稱英文
					cn_planned_company_name_en: '', //公司名稱英文 
					cn_planned_industry_name_en: '', //行業英文 
					"stockcode": "", //輸入股票代碼
					"stockname": "", //輸入股票名稱
					"offer_price_l": '', //招股價起始值
					"offer_price_h": '', //招股價最大值
					"pergshu": '', //每手股數
					"application_open": "", //認購日期起始
					"application_close": "", //認購日期截止
					"listingdate": "", //上市日期
					"entryfee": '', //入場費
					"cn_planned_company_name_cn": "", //公司名稱
					"cn_planned_industry_name_cn": "", //上市行業
					"status_cn": "", //上市狀態   已上市 （股票名称 股票代码）
					"plates_cn": "", //上市板塊
					"delivery_date": "", //遞表日期
					"baojianr": "", //保薦機構
					"anpantime": "", //暗盤時間
					"multiple": '', //認購倍數
					info: '',
					linkaddress: '',
					linkaddress_en:'',
					pricefileid: '',
					loan_ratio: '', // 比率
					loan_days: '', // 日數
					gain: '', // 利息
					ipo_type: '', // 新股种类
					// "adminid": "", // 錄入人唯一標識
				},
			}
		},
		mounted() {
			let obj = JSON.parse(JSON.stringify(this.forms))
			obj.baojianr_enval = obj.baojianr_en
			obj.baojianrval = obj.baojianr
			this.baojianr_div_en = obj.baojianr_en
			this.baojianr_div_ch = obj.baojianr
			this.form = JSON.parse(JSON.stringify(obj))
			console.log(this.form.offer_price_h);
			this.form.offer_price_h = Number(this.form.offer_price_h).toFixed(2)
			this.form.offer_price_l = Number(this.form.offer_price_l).toFixed(2)
			this.lang = this.england == 'cn' ? this.$big5.sub : this.$eng.sub
		},
		methods: {
			savefn(){
				this.$refs.ruleForm.validate(valid => {
				if (valid) {
						if (!this.baojianr_div_en || !this.baojianr_div_ch) {
							this.cla1 = true
							this.cla2 = true
							return
						}
						this.form.baojianr = this.baojianr_div_ch
						this.form.baojianr_en = this.baojianr_div_en
						this.form.baojianrval = this.baojianr_div_ch
						this.form.baojianr_enval = this.baojianr_div_en
						this.$ajax({
							method:'post',
							url:this.$api.newIpoSellingAudit,
							data:this.form
						}).then(res=>{
							if(res.data.qmiscode === 1000){
								this.$message.success(res.data.qmismsg)
								this.$emit('child','save',res.data.id)
							}else{
								this.$message.warning(res.data.qmismsg)
							}
						})
					}else{
						console.log(123123123123);
					}
					
				})
			},
			gopagefn() {
				this.$refs.ruleForm.validate(valid => {
				if (valid) {
						this.form.baojianr = this.baojianr_div_ch
						this.form.baojianr_en = this.baojianr_div_en
						this.form.baojianrval = this.baojianr_div_ch
						this.form.baojianr_enval = this.baojianr_div_en
						if (!this.baojianr_div_en || !this.baojianr_div_ch) {
							this.cla1 = true
							this.cla2 = true
							return
						}
						this.$emit("child","handhome3")
					}
				})
			},
			compareDate(dateTime1, dateTime2) {
				var formatDate1 = new Date(this.form[dateTime1])
				var formatDate2 = new Date(this.form[dateTime2])
				if (formatDate1 > formatDate2) {
					this.form[dateTime1] = '';
				}
			},
			handback(val) {
				this.form[val] = this.form[val] ? App.oDate.secsTime3(this.form[val]._d) : ''
				//（遞表日期）》啟示認購日期 》 終止認購日期》（上市日期）
				if (val == 'application_close' || val == 'application_open') {
					if (this.form.application_close && this.form.application_open) {
						this.compareDate('application_open', 'application_close')
					}
				}
				//遞表日期》上市日期
				if (val == 'delivery_date' || val == 'listingdate') {
					if (this.form.delivery_date && this.form.listingdate) {
						this.compareDate('delivery_date', 'listingdate')
						// anpantime
					}
				}
				//（遞表日期）》啟示認購日期
				if (val == 'delivery_date' || val == 'application_open') {
					if (this.form.delivery_date && this.form.application_open) {
						this.compareDate('delivery_date', 'application_open')
					}
				}
				//終止認購日期》（上市日期）
				if (val == 'application_close' || val == 'listingdate') {
					if (this.form.application_close && this.form.listingdate) {
						this.compareDate('application_close', 'listingdate')
					}
				}
			
			
				//暗盤日期 獲取上市日期前一天
				if (this.form.listingdate) {
					// this.form.anpantime = this.getNextDate(this.form.listingdate, -1)
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'application_close') {
					if (this.form.anpantime && this.form.application_close) {
						this.compareDate('application_close', 'anpantime')
					}
				}
				//暗盤日期》（上市日期）
				if (val == 'anpantime' || val == 'delivery_date') {
					if (this.form.anpantime && this.form.delivery_date) {
						this.compareDate('delivery_date', 'anpantime')
					}
				}
			},
			//彈出前操作
			moreEvent2() {
				this.visibles2 = !this.visibles2
				this.$set(this.form, 'baojianr_enval', JSON.parse(JSON.stringify(this.form.baojianr_en)))
			},
			moreEvent1() {
				this.visibles1 = !this.visibles1
				this.$set(this.form, 'baojianrval', JSON.parse(JSON.stringify(this.form.baojianr)))
			},
			//禁止選擇(大于)
			applicationDate(current) {
				return current && current > new Date(this.form.anpantime)
			},
			baofn() {
				this.form.baojianr = this.form.baojianr.replace(/[,]+/g, '')
			},
			//禁止選擇
			deliveryDate(current) {
				console.log( current > new Date(this.form.listingdate),current < new Date(this.form.delivery_date))
				return (current && current > new Date(this.form.listingdate))||(current &&current < new Date(this.form.delivery_date))
			},
			getCurrentStyle(current, today) {
				const style = {};
				if (current.date() === 1) {
					style.border = '1px solid #1890ff';
					style.borderRadius = '50%';
				}
				return style;
			},
			//禁止選擇(小于)
			disabledDate(current) {
				return current && current < new Date(this.getNextDate(this.form.delivery_date, 1))
			},
			addopen() {
				if (this.form.cn_planned_company_name_cn && (this.form.offer_price_h || this.form.offer_price_l)) {
					this.visibleadd = true
				} else {
					this.$message.warning(this.lang.pln + this.lang.comname + ',' + this.lang.price)
				}
			},
			// getdata(record = this.record) {
			// 	let _this = this;
			// 	let json = {
			// 		token: _this.$store.state.token,
			// 	}
			// 	https.fetchPost(apiUrl.getAdminRemarks, {
			// 		admintype: _this.forms.admintype,
			// 		token: json.token,
			// 		id: record.pdfcode,
			// 	}, json).then((data) => {
			// 		if (Object.is(data.qmiscode, 1000)) {
			// 			this.form.aduit = data.aduit;
			// 			this.form.ishanding = data.ishanding == '1' ? true : false;
			// 			this.form.shShowBol = true;
			// 			this.form.shKhadmin1Bol = (record.ishanding && _this.forms.admintype == 'khadmin1') && !(
			// 				record.schedule == 1 && record.status == 1);
			// 		} else {
			// 			App.oTool.warningT(data.qmismsg);
			// 		}
			// 	}).catch(err => {
			// 		console.log(err);
			// 	});
			// },
			stockcodeFn(value, zero) {
				if(String(Number(this.form[value])) == 'NaN'){
					this.form[value] = ''
				}else{
					if(zero){
						if(Number(this.form[value]).toFixed(2)>0){
							this.form[value] = Number(this.form[value]).toFixed(2)
						}else{
							this.form[value] = ''
							}
					}else{
						this.form[value] = this.form[value]
					}
				}
				/* this.form[value] = App.isnumdate(this.form[value], zero) */
				if (this.form.offer_price_l && this.form.offer_price_h) {
					if (this.form.offer_price_l * 1 > this.form.offer_price_h * 1) {
						let num = this.form.offer_price_h
						this.form.offer_price_h = this.form.offer_price_l
						console.log(num)
						this.form.offer_price_l = num
					}
				}
			},
			//前后一天
			getNextDate(date, day) {
				var dd = new Date(date);
				dd.setDate(dd.getDate() + day);
				var y = dd.getFullYear();
				var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
				var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
				return y + "-" + m + "-" + d;
			},
			exchangeRateClick(value){
				console.log(value,"子組件返回值");
				if (value.length>0) {
					let bjarr_ch =[]
					let bjarr_en =[]
					for (let i = 0; i < value.length; i++) {
						bjarr_ch.push(value[i].value_ch)
						bjarr_en.push(value[i].value_en)
					}
					console.log(bjarr_ch ,bjarr_en);
					this.baojianr_div_ch = bjarr_ch.join(';');
					this.baojianr_div_en = bjarr_en.join(';');
				}
				this.baojiaFlag = false;
			},		
			add_inp(){
				this.cla1 = false
				this.cla2 = false
				if (!this.ipoAduitAdmin) {
					this.baojiaFlag=true
				}
			}
		}
	}
</script>

<style>
	.myupload{
		z-index:1111;cursor: pointer;
			position: absolute;right: 0.5rem;width: .7rem;top: 0.2rem;
	}
	@media screen and (min-width:1924px){
		.myupload{
			top: 0.45rem;
			right: 0.8rem;
		}
	}
</style>
